/**
 * tool function
 */
import _ from "lodash";

/**
 * validate email
 * @param email
 * @returns
 */
export function validateEmail(email: string) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
}

/**
 * validate password
 * @param password
 * @returns
 */
export function validatePassword(password: string) {
    //const passRegex = /^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z0-9]{6,16}$/;
    // const passRegex = /^([A-Za-z0-9]).{6,25}$/;
    // 正则表达式：至少一个特殊字符或一个大写字母，且长度超过6个字符
    const passRegex = /^(?=.*[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]|.*[A-Z]).{6,25}$/;
    return passRegex.test(password);
}

/**
 * validate login password
 * @param name
 * @returns
 */
export function validateLoginPassword(name: string) {
    const regex = /^([A-Za-z0-9]).{6,25}$/;
    return regex.test(name);
}

/**
 * validate userName
 * @param password
 * @returns
 */
export function validateUserName(name: string) {
    const regex = /^([\u4e00-\u9fa5]{1,50}|[a-zA-Z\\.\s]{3,50})$/;
    return regex.test(name);
}

/**
 * 纯字母
 * @param str
 * @returns
 */
export function isLetterOnly(str: string) {
    return /^[A-Za-z\s]+$/.test(str);
}

/**
 * 特殊字符转换
 * @param input
 * @returns
 */
export function convertUnicode(input: string) {
    return input.replace(/\\+u([0-9a-fA-F]{4})/g, (a, b) =>
        String.fromCharCode(parseInt(b, 16))
    );
}

/**
 * url截取文件名已文件后缀
 * @param urlPath
 * @returns
 */
export function getFilenameFromUrl(urlPath: string) {
    if (!urlPath) {
        return null;
    }
    const url: any = new URL(urlPath);
    const pathname: string = url.pathname;
    const result = pathname.match(/.*\/(.+)$/);
    return result ? result[1] : null;
}

/**
 * 判断是否是图片文件格式
 * @param fileType
 * @returns
 */
export function isImageFileType(fileType: string) {
    const regex = /(\.|\/)(jpg|jpeg|png|gif|bmp|webp)$/i;
    return regex.test(fileType);
}

/**
 * 判断是否是视频文件格式
 * @param fileType
 * @returns
 */
export function isVideoFileType(fileType: string) {
    const regex = /(\.|\/)(mp4|avi|mpg|mov|wmv|flv|webm)$/i;
    return regex.test(fileType);
}

/**
 * 获取数组里的随机个数
 * @param arr
 * @param count
 * @returns
 */
export function getRandomElements(arr: any[], count: number) {
    const result = new Array(count);
    const len = arr.length;
    const taken = new Set();
    for (let i = 0; i < count; i++) {
        let index;
        do {
            index = Math.floor(Math.random() * len);
        } while (taken.has(index));
        taken.add(index);
        result[i] = arr[index];
    }
    return result;
}

/**
 * 去掉字符的前后空格
 * @param str
 * @returns
 */
export function trim(str: string | undefined | null) {
    if (!str) {
        return str;
    }
    return str.replace(/^\s+|\s+$/g, "");
}
/**
 * 去掉字符串所有空格
 * @param str
 * @returns
 */
export function removeSpaces(str: string | undefined | null) {
    if (!str) {
        return str;
    }
    return str.replace(/\s+/g, "");
}

/**
 * 判断字符尾部是否有空格
 * @param str
 * @returns
 */
export function endWithSpace(str: string) {
    return /\s$/.test(str);
}

/**
 * 判断字符包含空格
 * @param str
 * @returns
 */
export function strWithSpace(str: string) {
    return /\s/g.test(str);
}

/**
 * 防抖函数
 * @param func
 * @param delay
 * @returns
 */
export function debounce<T extends (...args: any[]) => any>(
    func: T,
    wait: number
): (...args: Parameters<T>) => void {
    let timeout: ReturnType<typeof setTimeout> | null = null;
    return function (this: any, ...args: Parameters<T>): void {
        clearTimeout(timeout!);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, wait);
    };
}

/**
 * 根据某个集合构造tree树状数据
 * @param {*} node
 * @param {*} nodesTag
 */
export function buildTreeNode(
    data: Array<unknown> | null | undefined,
    nodesTag: any[]
) {
    const res: { key: string; value: any; label: any }[] = [];
    if (nodesTag.length > 0) {
        const childRenNodes = _.groupBy(data, _.get(nodesTag, [0]).key);
        //console.log("childRenNodes",childRenNodes)
        _.forEach(childRenNodes, (item: any[], key: any) => {
            const curItem = {
                key: key,
                value: _.get(item, [0])[nodesTag[0].label],
                label: _.get(item, [0])[nodesTag[0].label],
            };
            const children = buildTreeNode(item, _.slice(nodesTag, 1));
            if (children.length > 0) {
                Object.assign(curItem, { children });
            }
            res.push(curItem);
        });
    }
    //console.log(res)
    return res;
}

export function formatTreeFlatNode(list: any[], node = "children") {
    const res: any[] = [];
    if (list.length > 0) {
        list.forEach((item) => {
            res.push([item]);
            if (item[node] && item[node].length > 0) {
                res.push([...formatTreeFlatNode(item[node], node)]);
            }
        });
    }
    return res;
}

/**
 * 获取树状结构最大层数
 */
export function getTreeMaxLevel(arr: any[], node = "children"): number {
    let maxLevel = 0;
    (function callBack(arr, level) {
        ++level;
        maxLevel = Math.max(level, maxLevel);
        for (let i = 0; i < arr.length; i++) {
            const item: any = arr[i];
            if (item[node] && item[node].length > 0) {
                callBack(item[node], level);
            } else {
                delete item[node];
            }
        }
    })(arr, 0);
    return maxLevel;
}

/**
 * 根据id获取树状数据里的目标数据
 * @param id
 * @param arr
 * @param node
 * @returns
 */
export function getLevelDataById(id: number, arr: any[], node = "children") {
    const res: any[] = [];
    for (let i = 0; i < arr.length; i++) {
        const item: any = arr[i];
        if (item?.id === id) {
            res.push(item);
        }
        if (item[node] && item[node].length > 0) {
            getLevelDataById(id, item[node], node);
        }
    }
    return res;
}

/**
 * 将24小时制时间范围转换为12小时制带am/pm的格式
 * @param timeRange - 格式为"HH:MM-HH:MM"的时间范围字符串
 * @returns 转换后的12小时制时间范围字符串
 */
export function convertTimeRangeTo12HourFormat(timeRange: string): string {
    const [startTime, endTime] = timeRange.split("-");

    const convertSingleTime = (time: string) => {
        const [hours, minutes] = time.split(":").map(Number);
        const period = hours >= 12 ? "PM" : "AM";
        const displayHours = hours % 12 || 12; // 将0转换为12
        return `${displayHours}:${minutes
            .toString()
            .padStart(2, "0")} ${period}`;
    };

    return `${convertSingleTime(startTime)}-${convertSingleTime(endTime)}`;
}

export function base64ToBlobUrl(base64Data: string, mimeType: string): string {
    // 移除可能的 data:URL 前缀
    const base64WithoutPrefix = base64Data.split(",")[1] || base64Data;

    // 将 Base64 转为二进制
    const byteString = atob(base64WithoutPrefix);
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
    }

    // 创建 Blob 并生成 URL
    const blob = new Blob([byteArray], { type: mimeType });
    return URL.createObjectURL(blob);
}

/**
 * 从视频URL截取指定帧的图片
 * @param videoUrl 视频URL
 * @param frameNumber 要截取的帧数（从0开始）
 * @param callback 回调函数，返回截取的图片DataURL
 * @param errorCallback 错误回调函数
 */
export async function captureVideoFrame(
    videoUrl: string,
    frameNumber: number,
    callback: (imageDataUrl: string) => void,
    errorCallback?: (error?: Error) => void
): Promise<void> {
    try {
        // 创建视频元素
        const video = document.createElement("video");
        video.crossOrigin = "anonymous"; // 处理跨域问题
        video.src = videoUrl;
        

        // 等待视频元数据加载完成
        await new Promise<void>((resolve, reject) => {
            video.addEventListener("loadedmetadata", () => resolve());
            video.addEventListener("error", (e) => {
                reject(new Error("video loading failed"));
            });
        });

        // 设置视频到指定帧附近的时间点
        const frameRate = 30; // 假设帧率为30fps，可根据实际情况调整
        const targetTime = Math.min(frameNumber / frameRate, video.duration);
        video.currentTime = targetTime;

        // 等待视频seek完成
        await new Promise<void>((resolve, reject) => {
            video.addEventListener("seeked", () => resolve());
            video.addEventListener("error", (e) => {
                reject(new Error("video seek failed"));
            });
        });

        // 创建canvas来捕获帧
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");

        if (!ctx) {
            throw new Error("can not get canvas context");
        }

        // 绘制视频帧到canvas
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // 获取图片数据URL
        const imageDataUrl = canvas.toDataURL("image/png");
        callback && callback(imageDataUrl);
    } catch (error) {
        console.error("video capture failed:", error);
        errorCallback && errorCallback(error instanceof Error ? error : new Error(String(error)));
    }
}

/**
 * 数组换位置
 * @param array 
 * @param from 
 * @param to 
 * @returns 
 */
export const moveItemInArray = <T>(array: T[], from: number, to: number) => {
  const item = array.splice(from, 1)[0];
  array.splice(to, 0, item)
  return array
};
